export const paragraphText =
  'Now you have access to dozens of incredible Session Musicians, Producers and Audio Engineers!';
export const bookSessionText = (isTrialOn?: boolean): string => isTrialOn ? 'BOOK YOUR FREE SESSION' : 'BOOK YOUR FIRST SESSION';
